import { render, staticRenderFns } from "./BuilingList.vue?vue&type=template&id=26998e56&"
import script from "./BuilingList.vue?vue&type=script&lang=js&"
export * from "./BuilingList.vue?vue&type=script&lang=js&"
import style0 from "./BuilingList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports